{{ value | dateRenderer }}
